import { ReactNode } from "react";
import { MessageBot } from "./MessageBot";

const BotWelcomeMessage = ({ icon }: { icon: ReactNode }) => (
  <MessageBot icon={icon}>
    <p>Hello, I'm a chatbot assistant. Ask me a question...</p>
  </MessageBot>
);

export default BotWelcomeMessage;
